import React, {useState} from 'react'
import styled from 'styled-components';
import ModalEnabled from "../../../../components/modalComponents/ModalEnabled";
import ActionGenericModal from "../../../../components/modal/ActionGenericModal";
import ObservarFalta from "./ObservarFalta";
import NoAprobarFalta from "./NoAprobarFalta";
import {aprobarFaltaAPI} from "../../../../consumers/backendApisUrls";
import AnularFalta from "./AnularFalta";

export const DetalleFaltaActions = ({refreshMainPage, toggleMainModal, formValues}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});

    return (
        <div className="modal-footer justify-content-end pr-4">
            <ModalEnabled modalEnabled={modalEnabled} setModalEnabled={setModalEnabled} refreshPage={refreshMainPage}/>
            <FooterButtons>

                {formValues?.PuedeAnular === true &&
                    <button
                        type="button"
                        className="btn btn-primary generic-button-ficha-modal generic-button-hover-rojo"
                        disabled={isSubmitting}
                        onClick={() => setModalEnabled({
                            isEnable: true,
                            component: AnularFalta,
                            data: {toggleMainModal, IdFalta: formValues?.IdFalta}
                        })}
                    >
                        Anular
                    </button>
                }
                {formValues?.PuedeRechazar === true &&
                    <button
                        type="button"
                        className="btn btn-primary generic-button-ficha-modal generic-button-hover-rojo"
                        disabled={isSubmitting}
                        onClick={() => setModalEnabled({
                            isEnable: true,
                            component: NoAprobarFalta,
                            data: {toggleMainModal, IdFalta: formValues?.IdFalta}
                        })}
                    >
                        No Aprobar
                    </button>
                }


                {formValues?.PuedeObservar === true &&
                    <button
                        type="button"
                        className="btn btn-primary generic-button-ficha-modal generic-button-hover-azul"
                        disabled={isSubmitting}
                        onClick={() => setModalEnabled({
                            isEnable: true,
                            component: ObservarFalta,
                            data: {toggleMainModal, IdFalta: formValues?.IdFalta}
                        })}
                    >
                        Observar
                    </button>
                }

                {formValues?.PuedeAprobar === true &&
                    <buttons
                        type="button"
                        className="btn btn-primary generic-button-ficha-modal generic-button-hover-verde"
                        disabled={isSubmitting}
                        onClick={(e) => {
                            e.preventDefault();
                            setModalEnabled({
                                isEnable: true, component: ActionGenericModal, data: {
                                    externalCallback: toggleMainModal,
                                    title: "Aprobar",
                                    actionLabel: "aprobar",
                                    api: aprobarFaltaAPI,
                                    name: formValues?.NombreEmpleado,
                                    payload: {IdFalta: formValues?.IdFalta}
                                }
                            })
                        }}
                    >
                        Aprobar
                    </buttons>
                }


            </FooterButtons>
        </div>
    )
};


const FooterButtons = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
`;